
<div class="page-customized">
    <v-progress-linear
        v-if="overlay"
        absolute
        indeterminate
    ></v-progress-linear>

    <app-bar
        :title="advice.exists() ? t('advice_title_update') : t('advice_title_create')"
        back="/app-contents/advices/advices"
    />

    <v-layout class="mt-n8">
        <v-card
            width="100%"
            color="transparent"
            elevation="0"
            class="pb-8"
        >
            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_name') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="advice.name"
                                type="text"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('name')"
                            ></v-text-field>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="advice.name"
                                :items="advice.translations['name']"
                                @touch="(v) => advice.translations['name'] = v"
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_section') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="advice.adviceSectionId"
                                :items="sections"
                                required
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('advice_section_id')"
                            ></v-select>
                        </div>
                    </div>
                    <div class="form-group-horizontal-cols">
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('advice_label_connected') }}</div>
                            <div class="horizontal-input">
                                <v-select
                                    v-model="advice.connected"
                                    :items="[ { text: '-', value: '' } ].concat(adviceConnects())"
                                    required
                                    outlined
                                    append-icon="mdi-chevron-down"
                                    dense
                                    :error-messages="form.errors.get('connected')"
                                ></v-select>
                            </div>
                        </div>
                        <div class="form-group-horizontal">
                            <div class="horizontal-label">{{ t('advice_label_connected_id') }}</div>
                            <div class="horizontal-input">
                                <v-text-field
                                    v-model="advice.connectedId"
                                    required
                                    outlined
                                    dense
                                    :error-messages="form.errors.get('connected_id')"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_description') }}</div>
                        <div class="horizontal-input">
                            <v-textarea
                                v-model="advice.description"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('description')"
                            ></v-textarea>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="advice.description"
                                :items="advice.translations['description']"
                                @touch="(v) => advice.translations['description'] = v"
                                text
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_level') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="advice.level"
                                :items="[ { text: '-', value: '' } ].concat(levels())"
                                required
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('level')"
                            ></v-select>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_stroke') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="advice.strokeId"
                                :items="strokes"
                                required
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('stroke_id')"
                            ></v-select>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_external_url') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="advice.externalUrl"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('external_url')"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_author') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="advice.author"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('author')"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('advice_label_sort_order') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="advice.sortOrder"
                                type="number"
                                step="1"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('sort_order')"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('general_action_published') }}</div>
                        <div class="horizontal-input">
                            <v-switch
                                class="ma-0"
                                v-model="advice.published"
                            ></v-switch>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-4">
                <v-btn
                    :to="{ name: 'advices' }"
                    class="mr-4"
                    color="primary"
                >{{ t('general_action_cancel') }}</v-btn>
                <v-btn
                    :loading="form.busy"
                    :disabled="form.busy"
                    color="orange"
                    @click.prevent="submit"
                >{{ advice.exists() ? t('general_action_save') : t('advice_title_create') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</div>
